<template>
  <div class="x-tablelist-view" data-automation="access">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @input="search"
      @search="search"
      @add="showAdd"
      @resetsearch="resetsearch"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        layout="total, sizes, prev, pager, next"
        :emptyText="$t('HT.nodata')"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import addAccess from './template/addAccess';
import bindApply from './template/bindApply';
import unbindApply from './template/unbindApply';
export default {
  components: {
    addAccess,
    bindApply,
    unbindApply
  },
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          type: 'input',
          key: 'name',
          placeholder: this.$t('HT.rules.addAccess.name'),
          width: '360px'
        },
        {
          type: 'button',
          text: this.$t('HT.reset'),
          plain: true,
          event: 'resetsearch'
        },
        {
          type: 'button',
          text: this.$t('HT.add'),
          icon: 'ux_icon_plus',
          hidden: !this.$hasModule(16),
          right: true,
          event: 'add'
        }
      ],
      columns: [
        // 表头数据
        {
          label: this.$t('HT.addAccess.name'),
          tooltip: true,
          align: 'left',
          render: (h, params) => {
            return h(
              'span',
              {
                class: ['x-table-blue-btn'],
                on: {
                  click: () => {
                    this.$router.push({ name: 'accessInfo', query: { id: params.id } });
                  }
                }
              },
              params.name
            );
          }
        },
        {
          label: this.$t('HT.access.type'),
          prop: 'type',
          tooltip: true,
          align: 'left',
          formatter: (row, column, cellValue) => {
            return cellValue === 'ALLOW' ? this.$t('HT.allow') : this.$t('HT.refuse');
          }
        },
        {
          label: this.$t('HT.createdTime'),
          prop: 'created_date',
          align: 'left',
          tooltip: true
        },
        {
          label: this.$t('HT.operation'),
          hidden: !this.$hasModule(16),
          align: 'left',
          render: (h, params) => {
            return h('my-table-btn', {
              props: {
                data: [this.$t('HT.manage'), this.$t('HT.delete')],
                colors: ['#0087ff'],
                event: ['edit', 'del']
              },
              on: {
                edit: () => {
                  this.$router.push({ name: 'accessInfo', query: { id: params.id } });
                },
                del: () => {
                  const title = this.$t('HT.access.del');
                  const content = this.$t('HT.access.del.content');

                  this.$uxModal.show({
                    title,
                    content,
                    confirm: () => {
                      this.delList(params.id);
                    }
                  });
                }
              }
            });
          }
        }
      ],
      filter: {
        // 查询参数
        name: '', // 访问策略名称
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      },
      applyList: []
    };
  },
  created() {
    this.getList(this.filter);
  },
  mounted() {
    this.getApplyList();
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.access.getList(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },
    /**
     * 重置搜索项
    */
    resetsearch() {
      console.log('重置');
      this.filter.name = '';
      this.search();
    },
    /**
     * 获取列表
     */
    getApplyList() {
      // this.$uxLoading.show();
      this.$api.apply.getList().then((res) => {
        if (res.code == 10000) {
          this.applyList = res.data;
        }
      });
    },

    /**
     * 添加列表
     * @param {Object} params 表单提交参数
     */
    addList(params) {
      this.$uxLoading.show();
      this.$api.access.addList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.addSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 修改列表
     * @param {Object} params 表单提交参数
     */
    putList(params) {
      this.$uxLoading.show();
      this.$api.access.putList(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.editSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 删除列表
     * @param {String} id 唯一标识
     */
    delList(id) {
      this.$uxLoading.show();
      this.$api.access.delList(id).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.delSuccess'));
          if (this.tableData.list.length === 1) {
            this.filter.page = this.filter.page - 1 ? this.filter.page - 1 : 1;
          }
          this.getList(this.filter);
        }
      });
    },

    /**
     * 新增-弹窗
     */
    showAdd() {
      const title = this.$t('HT.access.created');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addAccess, {});
        },
        confirm: (data) => {
          this.addList(data);
        }
      });
    },

    /**
     * 编辑
     * @param {Object} params 单行表格数据
     */
    showEdit(params) {
      const title = this.$t('HT.access.edit');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(addAccess, {
            props: { data: params }
          });
        },
        confirm: (data) => {
          this.putList(data);
        }
      });
    },

    /**
     * 绑定应用弹窗
     * @param {Object} params 查询对象
     */
    showBind(params) {
      const title = this.$t('HT.bindApply.appId');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(bindApply, {
            props: { data: params, list: this.applyList }
          });
        },
        confirm: (data) => {
          this.bind(data);
        }
      });
    },

    /**
     * 绑定应用
     * @param {Object} params 对象
     */
    bind(params) {
      this.$uxLoading.show();
      this.$api.access.bind(params).then((res) => {
        if (res.code == 10000) {
          this.$uxModal.hide();
          this.$uxMessage.success(this.$t('HT.addApi.bindSuccess'));
          this.getList(this.filter);
        }
      });
    },

    /**
     * 解绑应用弹窗
     * @param {Object} params 查询对象
     */
    showUnbind(params) {
      const title = this.$t('HT.access.unbind');
      this.$uxModal.show({
        title,
        content: (h) => {
          return h(unbindApply, {
            props: { data: params }
          });
        }
      });
    },

    /**
     * 搜索
     */
    search() {
      this.filter.page = 1;
      this.getList(this.filter);
    },

    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize() {
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage() {
      this.getList(this.filter);
    }
  }
};
</script>
